import React from 'react';
import { Row, Col } from 'antd';
import { ReactSVG } from 'react-svg';
import { AuthBackground, Aside, LeftShape, MainShape } from './overview/style';

const AuthLayout = (WraperContent) => {
  return function () {
    return (
      <AuthBackground>
        <Row>
        <Col xxl={12} xl={12} lg={12} md={{span:16, order:0}} xs={{span:24, order:1}}>
          <WraperContent />
        </Col>
          <Col xxl={12} xl={12} lg={12} md={{span:8, order:1}} xs={{span:24, order:0}}>
            <Aside>
              <div className="auth-side-content">
                <LeftShape>
                  <div className="left-svg">
                  <ReactSVG src={require(`../../static/img/logoShape.svg`).default} />
                  </div>
                </LeftShape>
                <MainShape>
                  <div className="middle-svg">
                    <img src={require('../../static/img/loginShape.png')} alt="" className="auth-img" />
                  </div>
                </MainShape>
              </div>
            </Aside>
          </Col>
      </Row>
    </AuthBackground>
    );
  };
};
export default AuthLayout;